import Axios, { InternalAxiosRequestConfig } from "axios";
import createNousContacterApi, {
  IApi as INousContacterApi,
} from "./NousContacter";

/**
 * Création du client Axios
 */
export const createAxiosClient = (endpoint: string) => {
  const axiosClient = Axios.create({
    baseURL: process.env.REACT_APP_API_HOST,
    // tslint:disable: quotemark
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // tslint:enable: quotemark
  });
  /* Intercepteur Axios
   */
  axiosClient.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      /**
       * Permet d'ajouter dans le header de nos requêtes les identifiants de connexion.
       */

      // Do something before request is sent
      return config;
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error);
    },
  );

  return axiosClient;
};

/**
 * Crée un nouveau client d'API
 * @param endpoint
 */
const create = (endpoint: string): IApi => {
  const axiosClient = createAxiosClient(endpoint);

  return {
    ...createNousContacterApi(endpoint, axiosClient),
  };
};

// Fusion des interfaces des API en une interface unique

export type IApi = INousContacterApi;

export default { create };
